import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useSession } from '../hooks/useSession'
import { DashboardSkeleton } from './Skeleton'

type ProtectedRouteProps = {
  requireAgency?: boolean
}

export default function ProtectedRoute({ requireAgency = false }: ProtectedRouteProps) {
  const { user, loading } = useSession()
  const location = useLocation()

  if (loading) {
    return <DashboardSkeleton />
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />
  }

  /*
   * A superadmin is cross-agency by definition and correctly has no
   * agency_id, but this guard sent them to /onboarding - so the person who
   * runs the platform was told to create an agency before they could reach
   * the page that administers every agency.
   *
   * AppLayout takes it from here: agency-scoped pages say they have no
   * agency rather than rendering an empty book that reads like one.
   */
  if (requireAgency) {
    const userAgencyId = (user as any)?.agency_id
    const isSuperAdmin = (user as any)?.role === 'superadmin'
    if (!userAgencyId && !isSuperAdmin) {
      return <Navigate to="/onboarding" replace />
    }
  }

  return <Outlet />
}
